import { useCallback, useReducer, useEffect } from "react";
import { AppAPIService } from "../../../../../../../services/AppAPIService";

const ACTIONS = {
  MAKE_REQUEST: "make-request",
  GET_DATA: "get-data",
  ERROR: "error",
  FETCHED: "fetched",
  RESET: "reset",
};

function reducer(state, action) {
  if (action.type === ACTIONS.MAKE_REQUEST) {
    return { ...state, isLoading: true };
  }
  if (action.type === ACTIONS.GET_DATA) {
    return {
      ...state,
      isLoading: false,
      isFetched: true,
      data: action.payload.data ?? [],
    };
  }
  if (action.type === ACTIONS.ERROR) {
    return {
      ...state,
      isLoading: false,
      isFetched: true,
      error: action.payload.error,
    };
  }
  if (action.type === ACTIONS.FETCHED) {
    return { ...state, isFetched: true };
  }
  if (action.type === ACTIONS.RESET) {
    return {
      ...state,
      data: [],
      isLoading: true,
      isFetched: false,
    };
  }
  return state;
}

export default function useFetchData({ queryParams }) {
  let api = AppAPIService.getInstance();
  const [state, dispatch] = useReducer(reducer, {
    data: [],
    isLoading: true,
    isFetched: false,
  });
  const params = new URLSearchParams(queryParams).toString();
  const refetch = useCallback(() => {
    dispatch({ type: ACTIONS.RESET });
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: ACTIONS.MAKE_REQUEST });
      try {
        const data = await api.makeHttpRequest({
          url: `/process-logs/list-paginated?${params}`,
          method: "GET",
        });
        dispatch({ type: ACTIONS.GET_DATA, payload: { data } });
      } catch (error) {
        console.log(error);
        dispatch({ type: ACTIONS.ERROR, payload: { error } });
      }
    };

    if (!state.isFetched && (!state.data || state.data.length === 0)) {
      fetchData();
    }
  }, [api, params, state.isFetched, state.data]);

  return { ...state, refetch };
}
